import React, { useState } from "react";
import "./Card.css";
import { motion, AnimateSharedLayout } from "framer-motion";
import { UilTimes } from "@iconscout/react-unicons";
import Chart from "react-apexcharts";
import { formatDate } from "../../Functions/Functions";

// parent Card
export default function Card(props){
  const [expanded, setExpanded] = useState(false);
  
  return (
    <AnimateSharedLayout>
      {expanded ? (
        <ExpandedCard xAxis={props.xAxis} startDate={props.startDate} endDate={props.endDate} param={props} setExpanded={() => setExpanded(false)} />
      ) : (
        <CompactCard startDate={props.startDate} endDate={props.endDate} param={props} setExpanded={() => setExpanded(true)} />
      )}
    </AnimateSharedLayout>
  );
};

// Compact Card
function CompactCard({ param, setExpanded, startDate, endDate }) {
  
    // Custom date formatting function
    const formatDate = (date) => {
      if (!date) return '';
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-indexed
      return `${day}/${month}`;
    };

  const Png = param.png;
  const pct = Number.isFinite(param.barValue) ? param.barValue : 0;
  const variant = param.color.variant || "light";

  return (
    <motion.div
      className={`CompactCard CompactCard--${variant}`}
      style={{
        background: param.color.backGround,
        boxShadow: param.color.boxShadow,
        "--card-fg": param.color.text || "#fff",
      }}
      layoutId="expandableCard"
      onClick={setExpanded}
    >
      <div className="kpi-top">
        <span className="kpi-chip">{pct >= 0 ? "+" : ""}{pct}%</span>
        <span className="kpi-icon">
          <Png size={16} />
        </span>
      </div>
      <div className="kpi-value">{param.value}</div>
      <div className="kpi-name">{param.title}</div>
      <div className="kpi-range">
        {
          formatDate(startDate) === formatDate(endDate) ? formatDate(startDate) : `${formatDate(startDate)} - ${formatDate(endDate)}`
        }
      </div>
    </motion.div>
  );
}

// Expanded Card
function ExpandedCard({ param, setExpanded, startDate, endDate, xAxis }) {

  const data = {
    options: {
      chart: {
        type: "area",
        height: "auto",
      },

      dropShadow: {
        enabled: false,
        enabledOnSeries: undefined,
        top: 0,
        left: 0,
        blur: 3,
        color: "#000",
        opacity: 0.35,
      },

      fill: {
        colors: ["#fff"],
        type: "gradient",
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        colors: ["white"],
      },
      tooltip: {
        x: {
          format: "dd/MM/yy",
        },
      },
      grid: {
        show: true,
      },
      xaxis: {
        type: "date",
        categories:xAxis
      },
    },
  };

  return (
    <motion.div
      className="ExpandedCard"
      style={{
        background: param.color.backGround,
        boxShadow: param.color.boxShadow,
      }}
      layoutId="expandableCard"
    >
      <div style={{ alignSelf: "flex-end", cursor: "pointer", color: "white" }}>
        <UilTimes onClick={setExpanded} />
      </div>
        <span>{param.title}</span>
      <div className="chartContainer">
        <Chart options={data.options} series={param.series} type="area" />
      </div>
      <span>
          {
            formatDate(startDate) === formatDate(endDate) ? formatDate(startDate) : `${formatDate(startDate)} - ${formatDate(endDate)}`
          }
        </span>
    </motion.div>
  );
}

